import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files directly (simpler for CRA)
import enCommon from './locales/en/common.json';
import enHome from './locales/en/home.json';
import enAbout from './locales/en/about.json';
import enServices from './locales/en/services.json';
import enBlog from './locales/en/blog.json';
import enScheduler from './locales/en/scheduler.json';

import daCommon from './locales/da/common.json';
import daHome from './locales/da/home.json';
import daAbout from './locales/da/about.json';
import daServices from './locales/da/services.json';
import daBlog from './locales/da/blog.json';
import daScheduler from './locales/da/scheduler.json';

const resources = {
    en: {
        common: enCommon,
        home: enHome,
        about: enAbout,
        services: enServices,
        blog: enBlog,
        scheduler: enScheduler,
    },
    da: {
        common: daCommon,
        home: daHome,
        about: daAbout,
        services: daServices,
        blog: daBlog,
        scheduler: daScheduler,
    },
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'en',
        defaultNS: 'common',
        ns: ['common', 'home', 'about', 'services', 'blog', 'scheduler'],

        // Language detection options
        detection: {
            // Detect language from URL path first (e.g., /en/about-us)
            order: ['path', 'localStorage', 'navigator'],
            lookupFromPathIndex: 0,
            caches: ['localStorage'],
        },

        interpolation: {
            escapeValue: false, // React already escapes values
        },

        react: {
            useSuspense: false, // Disable suspense for simpler setup
        },
    });

export default i18n;
